/**
 * CommentList — Scrollable list of voice comments in the feedback panel.
 *
 * Renders a CommentCard for each comment in the current session.
 * Displays an empty-state message when no comments exist yet.
 */
import type { VoiceComment } from "../../types/feedback";
import { CommentCard } from "./CommentCard";

interface CommentListProps {
  readonly comments: VoiceComment[];
  readonly onDelete: (index: number) => void;
}

export function CommentList({ comments, onDelete }: CommentListProps) {
  if (comments.length === 0) {
    return (
      <div className="fb-comment-list-empty">
        <p>No comments yet.</p>
        <p className="fb-comment-list-hint">
          Press the microphone button to start recording.
        </p>
      </div>
    );
  }

  return (
    <div className="fb-comment-list">
      {comments.map((comment) => (
        <CommentCard
          key={comment.index}
          comment={comment}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
